<script setup lang="ts">
import type { Option } from '@/js/types/options.ts';
import { getLocaleValue } from '@/js/helper/locale.ts';
import { classname, formatPrice } from '@/js/utils.js';

const { totals } = defineProps<{
  totals: Option[]
  finalPrice: string
}>();
const cn = classname('product-cost');
</script>

<template>
  <div v-if="totals.length > 0" :class="cn()">
    <div :class="cn('products')">
      <div
        v-for="(total, index) in totals"
        :key="index"
        :class="cn('product')"
      >
        <div :class="cn('product-text')">
          {{ total.label }}
        </div>
        <div :class="cn('product-price')">
          {{ formatPrice(total.value) }}
        </div>
      </div>
    </div>
    <div :class="cn('price-wrapper')">
      <div :class="cn('price')">
        <div :class="cn('price-text')">
          {{ getLocaleValue('total') }}
        </div>
        <div :class="cn('price-value')">
          {{ finalPrice }}
        </div>
      </div>
      <!--      <div v-if="credit" :class="cn('price', { type: 'credit' })"> -->
      <!--        <div :class="cn('price-text')"> -->
      <!--          В кредит -->
      <!--        </div> -->
      <!--        <div :class="cn('price-value')"> -->
      <!--          от {{ credit }} ₽/мес. -->
      <!--        </div> -->
      <!--      </div> -->
    </div>
  </div>
</template>

<style lang='scss'>
.product-cost {
  &__products {
    display: grid;
    grid-gap: 13px;
    margin-top: 18px;
    padding-bottom: 12px;
    border-bottom: 1px solid #b2b2b2;
  }

  &__product {
    display: flex;
    grid-gap: 10px;
    align-items: center;
    justify-content: space-between;
    font-weight: 300;
  }

  &__product-text {
    max-width: 300px;
    font-size: 16px;
  }

  &__product-price {
    font-size: 20px;
    white-space: nowrap;

    &_type {
      &_promo {
        color: #ee4949;
      }
    }
  }

  &__price-wrapper {
    display: grid;
    grid-gap: 8px;
    margin-top: 18px;
  }

  &__price-text {
    font-size: 20px;
  }

  &__price-value {
    font-size: 31px;
  }

  &__price {
    display: flex;
    align-items: center;
    justify-content: space-between;

    &_type {
      &_credit {
        .product-cost__price-text {
          font-size: 18px;
        }

        .product-cost__price-value {
          color: #b2b2b2;
          font-weight: 300;
          font-size: 18px;
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    &__products {
      padding: 0 0 17px 0;
    }

    &__price-wrapper {
      margin-top: 25px;
      padding: 0;
    }
  }

  @media screen and (max-width: 500px) {
    &__product-price {
      font-size: 18px;
    }

    &__price-text {
      font-size: 16px;
    }

    &__price-value {
      font-size: 24px;
    }

    &__price {
      &_type {
        &_credit {
          .product-cost__price-text {
            font-size: 16px;
          }

          .product-cost__price-value {
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>
